export default {
    title: '',
    order: 0,
}